import {
    GET_CARD_TYPE_DEF_SUCCESS,
    CARD_TYPE_DEF_API_ERROR
} from "./actionTypes"

const INIT_STATE = {
    recordList: [], //Model Data ve Error
    error: {},
}

const cardTypeDef = (state = INIT_STATE, action) => {
    switch (action.type) {

        case GET_CARD_TYPE_DEF_SUCCESS:
            return {
                ...state,
                recordList: action.payload,
            }

        case CARD_TYPE_DEF_API_ERROR:
            return {
                ...state,
                error: action.payload,
            }

        default:
            return state
    }
}

export default cardTypeDef